import { Container, Sprite, Texture } from 'pixi.js'

// 貼圖按鈕 — 使用 Unity 既有按鈕素材；支援 off/on 兩態（toggle）與點擊回呼。
export class SpriteButton extends Container {
  private readonly sprite: Sprite
  private readonly offTexture: Texture
  private readonly onTexture: Texture
  private enabled = true
  private active = false
  private targetHeight = 64

  constructor(offTexture: Texture, onTexture: Texture | null, onTap: () => void) {
    super()
    this.offTexture = offTexture
    this.onTexture = onTexture ?? offTexture
    this.sprite = new Sprite(offTexture)
    this.sprite.anchor.set(0.5)
    this.addChild(this.sprite)

    this.eventMode = 'static'
    this.cursor = 'pointer'
    this.on('pointertap', () => {
      if (this.enabled) onTap()
    })
  }

  /** 依目標高度等比縮放（寬度自動）。 */
  setHeight(height: number): void {
    this.targetHeight = height
    this.applyScale()
  }

  /** 顯示寬度（依目前縮放）。 */
  get displayWidth(): number {
    const tex = this.sprite.texture
    return tex.height > 0 ? (tex.width * this.targetHeight) / tex.height : this.targetHeight
  }

  setActive(active: boolean): void {
    if (this.active === active) return
    this.active = active
    this.sprite.texture = active ? this.onTexture : this.offTexture
    this.applyScale()
  }

  setEnabled(enabled: boolean): void {
    this.enabled = enabled
    this.eventMode = enabled ? 'static' : 'none'
    this.alpha = enabled ? 1 : 0.5
  }

  private applyScale(): void {
    const tex = this.sprite.texture
    if (tex.height <= 0) return
    this.sprite.scale.set(this.targetHeight / tex.height)
  }
}
